import { Link } from "react-router-dom";
import { Sparkle } from "@phosphor-icons/react";
import { TermsContent } from "@/components/TermsContent";

export default function TermsPage() {
  return (
    <div className="min-h-screen bg-canvas text-ink">
      <nav className="px-5 sm:px-8 md:px-16 py-5 border-b border-line">
        <Link to="/" className="inline-flex items-center gap-2">
          <div className="w-6 h-6 rounded-full bg-clay/90 grid place-items-center">
            <Sparkle weight="fill" className="text-canvas" size={12} />
          </div>
          <span className="font-serif-display text-xl">Clarity Mirror</span>
        </Link>
      </nav>

      <article className="max-w-3xl mx-auto px-5 sm:px-8 py-16 prose-narrow">
        <TermsContent />
      </article>
    </div>
  );
}
